import { NAV_MODE } from "constant/navigation";
import { NavMode } from "type/navigation/nav_mode.type";

export function isEditMode(mode: NavMode): boolean {
  return mode === NAV_MODE.EDIT;
}
